import Alert from '@mui/material/Alert'
import type { SurveyQuestion } from '../../../lib/survey-question.types'

interface UnsupportedQuestionTypeProps {
  readonly question: SurveyQuestion
}

export function UnsupportedQuestionType({ question }: UnsupportedQuestionTypeProps) {
  return (
    <Alert severity="warning" data-testid="survey-unsupported-question">
      This question type ({question.type}) is not supported in the web survey yet. Please
      contact support or try again later.
    </Alert>
  )
}
